import React, { useState } from "react";
import "./Navbar.css";
import { useSelector } from "react-redux";
import logo from "../../Assets/logo.png";
import { Link } from "react-router-dom";
import { RiMenu2Line } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { FaRegUser } from "react-icons/fa6";
import { RiShoppingBagLine } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { FiHeart } from "react-icons/fi";
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Settings from '@mui/icons-material/Settings';
import { RiAdvertisementFill } from "react-icons/ri";
import { IoIosContact } from "react-icons/io";
import Logout from '@mui/icons-material/Logout';
import { useAuth } from "../../Auth/AuthContext copy";
import Loogin from "../../Components/Authentication/Login/Login"
import AccountSettings from '../../Components/Authentication/settings/AccountSettings';
import Profile from '../Authentication/settings/Profile';
// social Links imports Icons
import { useNavigate } from "react-router";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import Badge from "@mui/material/Badge";

const Navbar = () => {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };
  const { currentUser, setModal, logout, setAlert } = useAuth();
  const openLogin = () => {
    setModal({ isOpen: true, title: 'Login', content: <Loogin /> });
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      setAlert({
        isAlert: true,
        severity: 'error',
        message: error.message,
        timeout: 8000,
        location: 'main',
      });
      console.log(error);
    }
  };

  const handleNavigation = (pathname) => {
    if (currentUser && currentUser.emailVerified) {
      navigate(pathname);
      scrollToTop();
    } else if (currentUser && !currentUser.emailVerified) {
      setShowAlert(true);
    } else {
      openLogin();
    }
  };


  const cart = useSelector((state) => state.cart);
  const favoriteProductIds = useSelector((state) => state.favorites.favoriteProducts);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const handleMenuClose = () => {
    if (window.innerWidth <= 768) {
      toggleMobileMenu();
    }
  };
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = mobileMenuOpen ? "auto" : "hidden";
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {/* Desktop Menu */}
      <nav className="navBar">
        <div className="logoLinkContainer">
          <div className="logoContainer">
            {/* <Link to="/" onClick={scrollToTop}>
              <img src={logo} alt="Logo" />
            </Link> */}
             <h1 class="header-logo">Eadaad<span class="dot">.</span></h1>
          </div>
          <div className="linkContainer">
            <ul>
              <li>
                <Link to="/" onClick={scrollToTop}>
                  HOME
                </Link>
              </li>
              <li>
                <Link to="/shop" onClick={scrollToTop}>
                  SHOP
                </Link>
              </li>
              {/* <li>
                <Link to="/blog" onClick={scrollToTop}>
                  BLOG
                </Link>
              </li> */}
              <li>
                <Link to="/about" onClick={scrollToTop}>
                  ABOUT
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop}>
                  CONTACT
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="iconContainer">
          {/* <FiSearch size={22} onClick={scrollToTop} /> */}
          {/* <Link to="/login" onClick={scrollToTop}>
            <FaRegUser size={22} />
          </Link> */}
          <div className="loginPage">
            <Box sx={{}}>
              {!currentUser ? (
                <Link onClick={openLogin}>
                  <FaRegUser size={22} />
                </Link>
              ) : (
                <Tooltip title="Account settings">
                  <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                    <Avatar
                      sx={{ width: 28, height: 28 }}
                      src={currentUser?.photoURL}
                    >
                      {currentUser?.displayName?.charAt(0)?.toUpperCase() ||
                        currentUser?.email?.charAt(0)?.toUpperCase()}
                    </Avatar>
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <MenuItem
               sx={{ fontFamily: '"Jost", sans-serif' }}
                onClick={() =>
                  setModal({
                    isOpen: true,
                    title: 'Update Profile',
                    content: <Profile />,
                  })
                }
              >
                <Avatar src={currentUser?.photoURL} /> Profile
              </MenuItem>
              <Divider />
              <MenuItem
               sx={{ fontFamily: '"Jost", sans-serif' }}
                onClick={() =>
                  setModal({
                    isOpen: true,
                    title: 'Account Settings',
                    content: <AccountSettings />,
                  })
                }
              >
                <ListItemIcon>
                  <Settings fontSize="small" />
                </ListItemIcon>
                Settings
              </MenuItem>
              <Link style={{ textDecoration: 'none' }} to={{
                pathname: '/userorder',
              }} >
                <MenuItem
                 sx={{ fontFamily: '"Jost", sans-serif' }}
                 style={{ color: "black" }} >
                  <ListItemIcon>
                    <RiAdvertisementFill fontSize="large" />
                  </ListItemIcon>
                  Your Order
                </MenuItem>
              </Link>
              <Link style={{ textDecoration: 'none' }} to={{
                pathname: `/contact`,
              }} >
                <MenuItem 
                 sx={{ fontFamily: '"Jost", sans-serif' }}
                style={{ color: "black" }} >
                  <ListItemIcon>
                    <IoIosContact fontSize="large" />
                  </ListItemIcon>
                  Help & Contact
                </MenuItem>
              </Link>
              <MenuItem 
               sx={{ fontFamily: '"Jost", sans-serif' }}
              onClick={handleLogout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
          <Link to="/cart" onClick={scrollToTop}>
            <Badge
              badgeContent={cart.items.length === 0 ? "0" : cart.items.length}
              color="primary"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <RiShoppingBagLine size={22} />
            </Badge>
          </Link>
          <Badge
              badgeContent={favoriteProductIds.length === 0 ? "0" : favoriteProductIds.length}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'red',
                  color: 'white', // Text color
                }
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <FiHeart size={22} onClick={() => handleNavigation('/favorite')} />
            </Badge>
          
          
          {/* <RiMenu2Line size={22} /> */}
        </div>
      </nav>

      {/* Mobile Menu */}
      <nav>
        <div className="mobile-nav">
          {mobileMenuOpen ? (
            <MdOutlineClose size={22} onClick={toggleMobileMenu} />
          ) : (
            <RiMenu2Line size={22} onClick={toggleMobileMenu} />
          )}
          <div className="logoContainer">
            {/* <Link to="/">
              <img src={logo} alt="Logo" />
            </Link> */}
            <h1 class="header-logo">Eadaad<span class="dot">.</span></h1>
          </div>
          <Link to="/cart">
            <Badge
              badgeContent={cart.items.length === 0 ? "0" : cart.items.length}
              color="primary"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <RiShoppingBagLine size={22} color="black" />
            </Badge>
          </Link>
          <Badge
              badgeContent={favoriteProductIds.length === 0 ? "0" : favoriteProductIds.length}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'red',
                  color: 'white', // Text color
                }
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <FiHeart size={21} onClick={() => handleNavigation('/favorite')} />
            </Badge>
          
        </div>
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menuTop">
            <div className="mobile-menuSearchBar">
              {/* <div className="mobile-menuSearchBarContainer">
                <input type="text" placeholder="Search products" />
                <Link to="/shop">
                  <FiSearch size={22} onClick={toggleMobileMenu} />
                </Link>
              </div> */}
            </div>
            <div className="mobile-menuList">
              <ul>
                <li>
                  <Link to="/" onClick={toggleMobileMenu}>
                    HOME
                  </Link>
                </li>
                <li>
                  <Link to="/shop" onClick={toggleMobileMenu}>
                    SHOP
                  </Link>
                </li>
                {/* <li>
                  <Link to="/blog" onClick={toggleMobileMenu}>
                    BLOG
                  </Link>
                </li> */}
                <li>
                  <Link to="/about" onClick={toggleMobileMenu}>
                    ABOUT
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={toggleMobileMenu}>
                    CONTACT
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mobile-menuFooter">
            <div className="mobile-menuFooterLogin">
              {/* <Link to="/loginSignUp" onClick={toggleMobileMenu}>
                <FaRegUser />
                <p>My Account</p>
              </Link> */}
              <Box sx={{}}>
                {!currentUser ? (
                  <Link onClick={openLogin}>
                    <FaRegUser size={22} />
                    <p>My Account</p>
                  </Link>
                ) : (
                  <Tooltip title="Account settings">
                    <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                      <Avatar
                        sx={{ width: 28, height: 28 }}
                        src={currentUser?.photoURL}
                      >
                        {currentUser?.displayName?.charAt(0)?.toUpperCase() ||
                          currentUser?.email?.charAt(0)?.toUpperCase()}
                      </Avatar>
                      <Box sx={{ pl: 2 }}>
                        <p>My Account</p>
                      </Box>
                    </IconButton>

                  </Tooltip>
                )}
              </Box>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  sx={{ fontFamily: '"Jost", sans-serif' }}
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: 'Update Profile',
                      content: <Profile />,
                    })
                  }
                >
                  <Avatar src={currentUser?.photoURL} /> Profile
                </MenuItem>
                <Divider />
                <MenuItem
                 sx={{ fontFamily: '"Jost", sans-serif' }}
                  onClick={() =>
                    setModal({
                      isOpen: true,
                      title: 'Account Settings',
                      content: <AccountSettings />,
                    })
                  }
                >
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>
                <Link style={{ textDecoration: 'none' }} to={{
                  pathname: '/userorder',
                }}
                onClick={handleMenuClose}
                >
                  <MenuItem
                   sx={{ fontFamily: '"Jost", sans-serif' }}
                   style={{ color: "black" }} >
                    <ListItemIcon>
                      <RiAdvertisementFill fontSize="large" />
                    </ListItemIcon>
                    Your Order
                  </MenuItem>
                </Link>
                <Link style={{ textDecoration: 'none' }} to={{
                  pathname: `/contact`,
                }}
                onClick={handleMenuClose}
                 >
                  <MenuItem
                   sx={{ fontFamily: '"Jost", sans-serif' }}
                   style={{ color: "black" }} >
                    <ListItemIcon>
                      <IoIosContact fontSize="large" />
                    </ListItemIcon>
                    Help & Contact
                  </MenuItem>
                </Link>
                <MenuItem 
                 sx={{ fontFamily: '"Jost", sans-serif' }}
                onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </div>
            <div className="mobile-menuFooterLangCurrency">
              {/* <div className="mobile-menuFooterLang">
                <p>Language</p>
                <select name="language" id="language">
                  <option value="english">United States | English</option>
                  <option value="Hindi">Hindi</option>
                  <option value="Germany">Germany</option>
                  <option value="French">French</option>
                </select>
              </div> */}
              {/* <div className="mobile-menuFooterCurrency">
                <p>Currency</p>
                <select name="currency" id="currency">
                  <option value="USD">$ USD</option>
                  <option value="INR">₹ INR</option>
                  <option value="EUR">€ EUR</option>
                  <option value="GBP">£ GBP</option>
                </select>
              </div> */}
            </div>
            <div className="mobile-menuSocial_links">
              <FaFacebookF />
              <FaXTwitter />
              <FaInstagram />
              <FaYoutube />
              <FaPinterest />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
